import { currentPage, initNewSection } from '../common/layout';
import { bannerLazyload } from '../common/utils/fn';
import '../common/jquery.sticky';
import initLoadMoreBtn from '../common/load-more-btn';

currentPage.pageInit = ($page, pageData, pageId) => {
    $(".sidebar").stickySidebar({containerSelector: ".content-area"});
    // bigImgLazyload();
    initLoadMoreBtn();
}
currentPage.pageLoadMore = ($html, $btnBox) => {
    $btnBox.replaceWith($html);
    //bigImgLazyload();
    bannerLazyload();
    $(".sidebar").stickySidebar({containerSelector: ".content-area"});
    initNewSection($html)
}